import {
  ArrowUp as ArrowUpIcon,
  DoubleArrowUp as DoubleArrowUpIcon,
  DragHandle as DragHandleIcon,
} from '@the-platform-group/component-library/Icons'
import { IRWIN_ASSISTANT_STATUS_MAPPING } from '@the-platform-group/component-library/IrwinAssistant'

const INITIAL_SORT_STATE = {
  field: 'requested_at',
  sort: 'desc',
}

const NO_ASSIGNEE_OPTION = {
  label: 'No assignee',
  value: 'no_assignee',
}

// Where a request originated; values match the `source` filter on GET v2/user_upload_requests
const SOURCE_OPTIONS = [
  { label: 'General', value: 'general' },
  { label: 'Itinerary', value: 'itinerary' },
  { label: 'Itinerary Upload', value: 'itinerary_upload' },
]

const SORT_COLUMN_MAPS = {
  requestedAt: 'requested_at',
  expectedDate: 'due_at',
}

const UPLOAD_REQUEST_TABLE_NAME = 'irwinAssistant/uploadRequestsTable'

const STATUSES = Object.entries(IRWIN_ASSISTANT_STATUS_MAPPING).flatMap(([_, values]) => values)

const COLUMN_DOWNLOAD_MAPS = {
  userEmail: 'requestor_email',
  userName: 'requested_by',
}

// TODO: REMOVE once new status pills can be displayed
const UPLOAD_STATUS = [
  { status: 'received', color: 'secondary.main' },
  { status: 'work_in_progress', color: 'warning.main' },
  { status: 'to_be_reviewed', color: 'primary.light' },
  { status: 'in_review', color: 'score.medium' },
  { status: 'hold', color: 'error.main' },
  { status: 'completed', color: 'success.main' },
]

// TODO: REMOVE once new status pills can be displayed
const UPLOAD_STATUS_STYLES = UPLOAD_STATUS.reduce((acc, curr) => {
  const key = ` .status-button-${curr.status} button`

  return { ...acc, [key]: { backgroundColor: curr.color, color: 'black' } }
}, {})

const PRIORITY_OPTIONS = {
  urgent: { icon: DoubleArrowUpIcon, color: 'error.dark', backgroundColor: 'error.background' },
  high: { icon: ArrowUpIcon, color: 'warning.dark', backgroundColor: 'warning.background' },
  medium: { icon: DragHandleIcon, color: 'primary.main', backgroundColor: 'primary.light' },
}

export {
  INITIAL_SORT_STATE,
  NO_ASSIGNEE_OPTION,
  SOURCE_OPTIONS,
  SORT_COLUMN_MAPS,
  COLUMN_DOWNLOAD_MAPS,
  UPLOAD_REQUEST_TABLE_NAME,
  UPLOAD_STATUS,
  STATUSES,
  UPLOAD_STATUS_STYLES,
  PRIORITY_OPTIONS,
}
